export const NOTIFICATION = {
    LEVEL: {
        SUCCESS: 'success', //default
        WARNING: 'warning',
        ERROR: 'error'
    },
    TYPE: {
        TOAST: 'toast'
    }
}